import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/all-function/loading.js");
